import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { datatableActions, datatableSelectors } from './store'

const DatatableShowFilter = () => {
	const dispatch = useDispatch()
	const show = useSelector(datatableSelectors.getShowFilterSwitch)

	const handleShowFilter = () => {
		dispatch(datatableActions.updateShowFilter({ showFilter: true }))
	}

	if (!show) {
		return null
	}
	return (
		<button onClick={handleShowFilter} type="button">
			<i className="fal fa-filter text-primary-400 text-2xl"></i>
		</button>
	)
}

export default DatatableShowFilter
